// extracted by mini-css-extract-plugin
export var blockContent = "BlockContent-module--blockContent--V7VhO";
export var blockContent_nested = "BlockContent-module--blockContent_nested--cgoUR";
export var section_filled = "BlockContent-module--section_filled--6cdga";
export var narrow = "BlockContent-module--narrow--T1k0F";
export var alignCenter = "BlockContent-module--alignCenter--2ZbVd";
export var nohyphen = "BlockContent-module--nohyphen--q4Cnm";